import {
  AdditionalOrderStatuses,
  FULFILLMENT_STATE_CANCELED,
  FULFILLMENT_STATE_COMPLETED,
  FULFILLMENT_STATE_REJECTED,
  FULFILLMENT_STATE_VERIFY_TRACKING_NUMBER,
  ORDER_STATE_CANCELED,
  ORDER_STATE_COMPLETED,
  ORDER_STATE_PROCESSING,
  RETAILER_STATE_CANCELED,
} from '../constants/orderStates';

export function isOrderInState(currentState, desiredStates) {
  return desiredStates.some((state) => currentState === state);
}

export function simplifyFulfillmentStatus(state) {
  return AdditionalOrderStatuses[state];
}

export function getBgColor(label, additionalInfo) {
  if (additionalInfo) {
    return [AdditionalOrderStatuses['expired'], AdditionalOrderStatuses['late']].some((state) => state === label)
      ? 'warning'
      : 'info';
  }
  return isOrderInState(label, [
    AdditionalOrderStatuses['canceled'],
    FULFILLMENT_STATE_REJECTED,
    FULFILLMENT_STATE_CANCELED,
  ])
    ? 'dark'
    : isOrderInState(label, [
        AdditionalOrderStatuses['fulfilled_partially'],
        AdditionalOrderStatuses['fulfilled'],
        FULFILLMENT_STATE_COMPLETED,
      ])
    ? 'secondary'
    : 'primary';
}

export function filterOrdersByStates(filter, title) {
  switch (title) {
    case ORDER_STATE_COMPLETED:
      filter.fulfillment_state = {
        $in: [FULFILLMENT_STATE_COMPLETED, FULFILLMENT_STATE_VERIFY_TRACKING_NUMBER],
      };
      filter.retailer_state = {
        $ne: RETAILER_STATE_CANCELED,
      };
      filter.processing_state = {
        $ne: ORDER_STATE_CANCELED,
      };
      break;
    case ORDER_STATE_CANCELED:
      Object.assign(filter, {
        $or: [
          {
            retailer_state: {
              $eq: RETAILER_STATE_CANCELED,
            },
          },
          {
            processing_state: {
              $eq: ORDER_STATE_CANCELED,
            },
          },
          {
            fulfillment_state: {
              $eq: FULFILLMENT_STATE_REJECTED,
            },
          },
        ],
      });
      break;

    case ORDER_STATE_PROCESSING:
      filter.fulfillment_state = {
        $notIn: [FULFILLMENT_STATE_COMPLETED, FULFILLMENT_STATE_VERIFY_TRACKING_NUMBER, FULFILLMENT_STATE_REJECTED],
      };
      filter.retailer_state = {
        $ne: RETAILER_STATE_CANCELED,
      };
      filter.processing_state = {
        $ne: ORDER_STATE_CANCELED,
      };
      break;

    default:
      break;
  }
}
